import * as THREE from 'three'

export const createRectsMeshes = (rects, options) => {
  const { color, scale, opacity = 1 } = options
  const material = new THREE.MeshBasicMaterial({
    color,
    opacity,
    transparent: true
  })
  const ring = new THREE.Group()

  const rectMeshes = rects.map(({ width, height, x, y }) => {
    const geometry = new THREE.PlaneGeometry(width * scale, height * scale)
    const rect = new THREE.Mesh(geometry, material)
    ring.add(rect)

    rect.position.set(x * scale, -y * scale, 0)

    return rect
  })

  return { rectMeshes, ring }
}
